var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPizapHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 794.7 750.2",
    enableBackground: "new 0 0 794.7 750.2",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer0_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M787,366.5c7.9-10.7,9.8-22,5.6-33.9c10.9-4.4-318-286.3-360.6-317.8C407-4.9,381.8-5,356.8,14.9 C165.3,174.5-12,338.7,2.3,332.6c-7,17.3,2.9,38.1,18.6,47.3c29.7,15.1,63.4-1.1,70.3,39.5c6,90.2-2.7,226.9,3.3,278.8 c1.5,19.4,4.9,32,10.4,38c19.2,22.8,146.7,10.2,188.2,13.4c0.7-47.4-3.5-243.8,8.9-251.4c5.6-6.1,39.2-9.3,93.4-9.3 c55.3-0.2,91.9,3.2,97,9.3c12.4,8.4,8.3,203.7,9,251.4c29.3-0.4,134.8,0.8,149.8-1.1c39.9-6.8,39.2-26.7,42.8-69.5 c0.8-18.2,1.6-146-1.1-192.6c-0.5-56.9-14.4-83.9,40.6-96.9C752.7,386.3,776,382.9,787,366.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPizapHomeIcon);
export default __webpack_public_path__ + "static/media/pizap_home_icon.1d5904a4.svg";
export { ForwardRef as ReactComponent };